import {
  Box,
  Button,
  Checkbox,
  LinkButton,
  Modal,
  Typography,
} from "@bca/ui-library";
import React, { useEffect, useState } from "react";
import buildSalesLiveUrl from "../../helpers/buildSalesLiveUrl";

interface TermsAndConditionsModalProps {
  catalogueRef: string;
  handleCloseModal: () => void;
}

const TermsAndConditionsModal: React.FunctionComponent<
  TermsAndConditionsModalProps
  > = ({ handleCloseModal, catalogueRef }) => {
  const [checked, setIsChecked] = useState(false);

  const handleTermsAndConditionsCheck = () => {
    setIsChecked(!checked);
    sessionStorage.setItem(catalogueRef, `${!checked}`);
  };

  const checkIfTAndCsHaveBeenAccepted = () => {
    setIsChecked(
      sessionStorage.getItem(catalogueRef) === "true" ? true : false
    );
  };

  useEffect(checkIfTAndCsHaveBeenAccepted, []);

  return (
    <Modal
      role="alertdialog"
      onClose={handleCloseModal}
      css={`
        padding: 0px;
      `}
    >
      <Box maxWidth="710px" margin="0px" padding="0px">
        <Typography
          fontSize="24px"
          fontWeight="500"
          textAlign="center"
          color="secondary-nav-blue"
          paddingX="160px"
          margin="0px"
          paddingTop="30px"
          paddingBottom="0px"
        >
          You’re about to enter our new Live Bidding experience
        </Typography>

        <Box paddingLeft="36px" paddingRight="60px" paddingTop="28px">
          <Typography
            fontSize="16px"
            fontWeight="400"
            color="grey-blue"
            marginTop="0px"
          >
            All entries of vehicles for sale and all purchases are subject to the BCA Conditions of Entry and Sale.
            These Conditions and other applicable Terms and Conditions are binding. Buyers must ensure they read and
            understand them.
          </Typography>
          <Typography fontSize="16px" fontWeight="400" color="grey-blue">
            If you bid, it is on the basis you have read, understood, and accepted the pre-sale information,
            and completed reasonable due diligence. If you have any concerns, then you should not bid.
          </Typography>
        </Box>
      </Box>
      <Box paddingLeft="36px" paddingRight="36px">
        <Box display="flex" flexDirection="row">
          <Checkbox
            id="terms-and-conditions"
            label="I accept BCA "
            checked={checked}
            onChange={handleTermsAndConditionsCheck}
          ></Checkbox>
          <LinkButton
            href={process.env.termsAndConditionsUrl}
            color="text-color-hover"
            shouldOpenInNewWindow
            variant="tertiary"
            css="
            text-decoration: underline;"
            marginLeft={0}
            paddingLeft={2}
          >
            Terms & Conditions
          </LinkButton>
        </Box>
        <Box
          display="flex"
          justifyContent="flex-end"
          mt="27px"
          marginBottom="36px"
        >
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            height="48px"
            width="68px"
            marginRight="24px"
            fontSize="14px"
            color="primary-light-blue"
          >
            Close
          </Button>
          <Box aria-disabled="true">
            <LinkButton
              shouldOpenInNewWindow={true}
              variant="primary"
              link={checked && buildSalesLiveUrl(catalogueRef)}
              onClick={handleCloseModal}
              // @ts-ignore
              disabled={!checked}
              height="48px"
              width="180px"
              fontSize="14px"
            >
              Continue
            </LinkButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default TermsAndConditionsModal;
